import { useContext } from "react";
import { useLocation } from "react-router-dom";
import Page from "src/components/Report/Page";
import jobContext from "src/context/jobContext";

export default function Page23() {
    const { job } = useContext(jobContext)
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let MBTITYPES = [
        "ENTJ",
        "INTJ",
        "INFJ",
        "ENFJ",
        "ENTP",
        "INTP",
        "INFP",
        "ENFP",
        "ESTP",
        "ISTP",
        "ISFP",
        "ESFP",
        "ESTJ",
        "ISTJ",
        "ISFJ",
        "ESFJ"
    ]

    let ravan1;
    let ravan2;
    let ravan3;
    let ravan4;
    if (JSON.parse(localStorage?.data)?.[jobId]?.ravan1 && JSON.parse(localStorage?.data)?.[jobId].ravan2 && JSON.parse(localStorage?.data)?.[jobId].ravan3 && JSON.parse(localStorage?.data)?.[jobId].ravan4) {
        ravan1 = JSON.parse(localStorage?.data)?.[jobId]?.ravan1
        ravan2 = JSON.parse(localStorage?.data)?.[jobId]?.ravan2
        ravan3 = JSON.parse(localStorage?.data)?.[jobId]?.ravan3
        ravan4 = JSON.parse(localStorage?.data)?.[jobId]?.ravan4
    } else {
        ravan1 = []
        ravan2 = []
        ravan3 = []
        ravan4 = []
    }
    let letters = [];
    if (ravan1["1"]) {
        letters.push("I")
    } else if (ravan1["2"]) {
        letters.push("I");
        letters.push("E");
    } else {
        letters.push("E")
    }

    if (ravan2["1"]) {
        letters.push("N")
    } else if (ravan2["2"]) {
        letters.push("N");
        letters.push("S");
    } else {
        letters.push("S")
    }

    if (ravan3["1"]) {
        letters.push("F")
    } else if (ravan3["2"]) {
        letters.push("F");
        letters.push("T");
    } else {
        letters.push("T")
    }

    if (ravan4["1"]) {
        letters.push("P")
    } else if (ravan4["2"]) {
        letters.push("P");
        letters.push("J");
    } else {
        letters.push("J")
    }

    const howManyLetters = (text) => {
        const myArray = text.split("")
        let count = letters.filter(element => myArray.includes(element));
        // console.log("count",count,"type",myArray);

        return count.length;
    }
    let squares = MBTITYPES.map(function (single) {
        let count = howManyLetters(single);
        return (<div className={`${count == 4 ? "!bg-green-600" : count == 3 ? "!bg-yellow-500" : count == 2 ? "!bg-orange-500" : count == 1 ? "!bg-red-600" : count == 0 ? "!bg-red-800" : "bg-brown-500"} flex bg-red-900 justify-center rounded-lg items-center p-10 py-8 text-2xl border-[2px] border-solid border-white font-bold text-white`}>{single}</div>)
    })
    return (
        <Page pageNumber={23}>
            <div className="font-bold text-lg">
                نوع شخصیت مناسب شغل
            </div>
            <p className="text-black text-justify">
                این بخش به ویژگی‌های شخصیتی مطلوب برای ایفای موفق نقش شغلی اشاره دارد که با ماهیت وظایف، محیط کاری و تعاملات سازمانی هم‌خوانی دارد. تیپ‌های شخصیتی مانند برون‌گرا، درون‌گرا، تحلیل‌گر، عمل‌گرا، خلاق یا منظم بسته به نیازهای شغل انتخاب می‌شوند. تعیین نوع شخصیت مناسب به جذب افراد هم‌راستا با فرهنگ سازمانی و افزایش رضایت شغلی کمک می‌کند. درج این بخش مبنایی برای مشاوره شغلی، توسعه فردی و طراحی مسیرهای حرفه‌ای فراهم می‌سازد.
            </p>
            <div className="flex gap-4">
                <div className="w-full grid grid-cols-4 rounded-lg border-[2px] border-solid border-green-900">
                    {squares}
                </div>
                <div className="w-[360px] max-w-[360px] min-w-[360px]">
                    <span className=" flex justify-center p-2 bg-green-700 text-white rounded-md w-full">شرح نوع شخصیت مناسب شغل</span>
                    <p className="text-gray-800 p-4 text-justify">
                        با توجه به تحلیل انجام شده، در وهله اول افرادی با گروه (ها) شخصیتی
                        {
                            MBTITYPES.map(function (single, index) {
                                let count = howManyLetters(single);
                                if (count == 4) {
                                    return (<span className="mx-1">{index > 0 ? " ،" + single : single}</span>)
                                }
                            })
                        }
                        برای شغل "{job?.title}" به نسبت سایر گروه‌ها مناسب‌ترین هستند. بعد از آن افرادی با تیپ (ها) شخصیتی{
                            MBTITYPES.map(function (single,index) {
                                let count = howManyLetters(single);
                                if (count == 3) {
                                    return (<span className="mx-1">{index > 0 ? " ،" + single : single}</span>)
                                }
                            })
                        }
                        در اولویت دوم انتخاب قرار می‌گیرند.
                    </p>
                </div>
            </div>
            <span className="mb-2 text-sm">سبز: بسیار مناسب، زرد: مناسب، نارنجی: تاحدی مناسب، قرمز: نامناسب </span>
            <div className="flex flex-col bg-gray-100 rounded-md p-2 !text-xs">
                <div className="flex gap-4 p-2">
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">INTJ</span>
                        <div className="w-full">
                            دارای افکاری بدیع و مبتکرانه بوده واز انرژی خوبی در جهت رسیدن
                            به اهداف و سازماندهی امور بهره می گیرند.
                        </div>
                    </div>
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ISTP</span>
                        <div className="w-full">
                            افرادی با نگاه نافذ، آرام و محتاط بوده و کنجکاوی منحصربه فردی در
                            تجزیه و تحلیل اطلاعات دارند
                        </div>
                    </div>
                </div>
                <div className="flex gap-4 p-2">
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ISTJ</span>
                        <div className="w-full">
                            افرادی جدی، آرام و منظم بوده و موفقیت را با تمرکز و پشتکار
                            بدست می آورند.
                        </div>
                    </div>
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">INTP</span>
                        <div className="w-full">
                            افرادی آرام و تودار بوده و در موشکافی مسائل، منطقی عمل می کنند.
                        </div>
                    </div>
                </div>
                <div className="flex gap-4 p-2">
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ISFJ</span>
                        <div className="w-full">
                            افرادی آرام، خوش برخورد، مسئولیت پذیرو وظیفه شناس هستند.
                        </div>
                    </div>
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ESTJ</span>
                        <div className="w-full">
                            واقع بین، اهل عمل و کم احساس بوده ودر زمینه تجارت و کارهای فنی
                            استعداد خاصی از خود نشان می دهند
                        </div>
                    </div>
                </div>
                <div className="flex gap-4 p-2">
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ESTP</span>
                        <div className="w-full">
                            واقع گرا بوده و بندرت نگران می شوند ودر کارهای خودعجله
                            چندانی به خرج نمی دهند.
                        </div>
                    </div>
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ENTJ</span>
                        <div className="w-full">
                            پرنشاط و صادق بوده و از بیان هوشیارانه وقدرت رهبری خوبی در فعالیتهای
                            مختلف برخوردار می باشند.
                        </div>
                    </div>
                </div>
                <div className="flex gap-4 p-2">
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ESFP</span>
                        <div className="w-full">
                            برون گرا، مهمان نواز و خوش برخورد بوده و اغلب با مردمو
                            موضوعات روزمره به راحتی کنار می آیند.
                        </div>
                    </div>
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ISFP</span>
                        <div className="w-full">
                            خستگی ناپذیر، خوش برخورد، حساس و کم ادعا بوده و از مخالفت زیاد
                            پرهیزمیکنند.
                        </div>
                    </div>
                </div>
                <div className="flex gap-4 p-2">
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">INFJ</span>
                        <div className="w-full">
                            آرام، با انگیزه و وظیفه شناس بوده و علاقه زیادی در کمک به
                            دیگران دارند.
                        </div>
                    </div>
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ENFP</span>
                        <div className="w-full">
                            پرحرارت و باروحیه بوده ودارای قوه تخیل وابتکار بالا می باشند.
                        </div>
                    </div>
                </div>
                <div className="flex gap-4 p-2">
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ENTP</span>
                        <div className="w-full">
                            صریح و بی ریا بوده،افرادی خالق، پرهیجان، باهوش، پرحرف و
                            رک محسوب می شوند
                        </div>
                    </div>
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ESFJ</span>
                        <div className="w-full">
                            خوش قلب، خوش صحبت، محبوب و مسئولیت پذیر بوده و از قدرت
                            مشارکت و کار گروهی خوبی برخوردار می باشند.
                        </div>
                    </div>
                </div>
                <div className="flex gap-4 p-2">
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">INFP</span>
                        <div className="w-full">
                            افرادی وفادار، پرحرارت و خوش برخورد بوده و علاقه فراوانی به
                            یادگیری ایده های جدید دارند.
                        </div>
                    </div>
                    <div className="flex-1">
                        <span className="w-[50px] text-lg">ENFJ</span>
                        <div className="w-full">
                            مسئولیت پذیر و دلسوز بوده ودر ارائه یک موضوع یا رهبری یک بحث
                            گروهی توانایی خاصی دارند.
                        </div>
                    </div>
                </div>
            </div>
        </Page>
    )
}